import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'commute_service_provided_organized_facility'

export const dataPointDefinition = {
  retracedId: 'commute_service_provided_organized_facility',
  name: 'Is the commute service provided by/ organized by the facility?',
  description:
    'If the service is organized by the facility (e.g., the facility hires a 3rd party service provider to provide the commute service, or the facility recommends a specific service that workers should use for their commute), answer Yes.',
  meta: {
    slcpMeta: {
      key: 'hs-fir-31',
      number: 'HS-FIR-17',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-fir-31', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31040,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
